import "./DesktopMonetizeAdvantages.css";
import { useLang } from "../../../../i18n/LangContext";
import lightIcon from "../../../../assets/desktopMonetize/advantages/lightweight.svg";
import nativeIcon from "../../../../assets/desktopMonetize/advantages/native.svg";

const icons = [lightIcon, nativeIcon];

export default function DesktopMonetizeAdvantages({ id = "advantages" }) {
  const { t } = useLang();
  const data = t?.monetizeAdvantages;
  if (!data) return null;

  return (
    <section id={id} className="mon-adv-root mon-adv-desktop" aria-label="Monetize advantages">
      <div className="mon-adv-wrap">
        <div className="mon-adv-head">
          <p className="mon-adv-eyebrow">{data.eyebrow}</p>
          <h2 className="mon-adv-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
        </div>

        <div className="mon-adv-grid">
          {data.cards?.slice(0, 2).map((card, index) => (
            <article key={card.title} className="mon-adv-card">
              <span className="mon-adv-dot mon-adv-dot--top" aria-hidden="true" />

              <div className="mon-adv-icon">
                <div className="mon-adv-icon-ring-main">
                  <div className="mon-adv-icon-ring">
                    {icons[index] ? (
                      <img src={icons[index]} alt={card.iconAlt || card.title} loading="lazy" />
                    ) : (
                      <div className="mon-adv-icon-ph" />
                    )}
                  </div>
                </div>
              </div>

              <header className="mon-adv-card-head">
                <h3 className="mon-adv-card-title">{card.title}</h3>
                {card.subtitle && <p className="mon-adv-card-kicker">{card.subtitle}</p>}
              </header>

              <p className="mon-adv-card-desc">{card.text}</p>

              <span className="mon-adv-dot mon-adv-dot--bottom" aria-hidden="true" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
